import React, { useEffect, useState } from "react"
import { NavLink } from "react-router-dom"
import { Bookmark, Heart, Home, Map, Search, User } from "react-feather"
import { motion } from "framer-motion"
import { PAGE_URLS } from "../../constants/page-urls"
import { useLanguageStore } from "../../state-management/languageStore"

function Nav() {
    const { translate } = useLanguageStore()
    const [isVisible, setIsVisible] = useState(true)
    const [lastScrollY, setLastScrollY] = useState(0)

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY
            const shouldBeVisible =
                currentScrollY > lastScrollY && currentScrollY > 200
            setIsVisible(!shouldBeVisible)
            setLastScrollY(currentScrollY)
        }

        const handleMouseMove = (e) => {
            if (!isVisible) {
                const distFromBottom = window.innerHeight - e.clientY
                if (distFromBottom <= 100) {
                    setIsVisible(true) // G�r nav synlig om muspekaren �r n�ra botten av f�nstret
                }
            }
        }

        window.addEventListener("scroll", handleScroll)
        window.addEventListener("mousemove", handleMouseMove)

        return () => {
            window.removeEventListener("scroll", handleScroll)
            window.removeEventListener("mousemove", handleMouseMove)
        }
    }, [lastScrollY])

    const renderNavLink = (path, IconComponent, label, altColor = false) => {
        return (
            <NavLink
                onClick={() => window.scrollTo({ top: 1 })}
                className="flex-grow flex flex-col justify-center items-center py-2"
                to={path}
                end={path === ""} // Use the `end` prop for exact matching on the "/app" path
            >
                {({ isActive }) => (
                    <>
                        <IconComponent
                            className={
                                isActive
                                    ? `${!altColor ? "fill-neutral-900 dark:fill-neutral-100 fg-color-1" : "fill-red-500 text-red-500"}`
                                    : `${altColor ? "text-red-400" : "fg-color-3"}`
                            }
                            size={24}
                            strokeWidth={1.5}
                        />
                        <span
                            className={
                                isActive
                                    ? `${altColor ? "text-red-500" : "fg-color-1"}`
                                    : `${altColor ? "text-red-400" : "fg-color-3"}`
                            }
                        >
                            {label}
                        </span>
                    </>
                )}
            </NavLink>
        )
    }

    return (
        <motion.nav
            initial={{ y: 0 }}
            animate={{ y: isVisible ? 0 : 100 }}
            transition={{ type: "spring", stiffness: 100, damping: 20 }}
            className="pb-safe bg-color-1 border-translate border-color-2 fixed bottom-0 left-0 w-full justify-stretch items-stretch z-[999]"
        >
            <ul className="flex justify-center items-center  flex-grow *:flex *:flex-grow text-[.6rem] max-w-4xl mx-auto ">
                <li>{renderNavLink(PAGE_URLS.HOME, Home, translate("nav.home"))}</li>
                <li>
                    {renderNavLink(PAGE_URLS.SEARCH, Search, translate("nav.search"))}
                </li>
                <li>
                    {renderNavLink(PAGE_URLS.SAVED, Bookmark, translate("nav.saved"))}
                </li>
                <li>
                    {renderNavLink(PAGE_URLS.PROFILE, User, translate("nav.profile"))}
                </li>
                <li>{renderNavLink(PAGE_URLS.MAP, Map, translate("nav.map"))}</li>
                <li>
                    {renderNavLink(
                        PAGE_URLS.MATCH_GAME,
                        Heart,
                        translate("nav.match"),
                        true,
                    )}
                </li>
            </ul>
        </motion.nav>
    )
}

export default Nav
